/**
 * AUTO-GENERATED. Do not edit.
 *
 * Source-string export of `worklets/bitcrusher.worklet.js`. Regenerated
 * on every build; consumers create a Blob URL from this string and pass
 * it to `engine.loadWorklet()` to register the AudioWorkletProcessor
 * without a separate file fetch.
 *
 * Edit `worklets/bitcrusher.worklet.js` and re-run `pnpm build` to
 * regenerate.
 */
export const BITCRUSHER_WORKLET_SOURCE = `// Evil Synth — Bitcrusher AudioWorklet processor.
//
// Two knobs' worth of degradation:
//   - bits: target bit depth (1..16). Quantizes each sample to a grid of
//     2^bits levels. 16 is transparent; 4 is noisy; 1 is square-wave-ish.
//   - freq: target sample rate (200..48000 Hz). Holds each input sample for
//     multiple output samples when freq < sampleRate; produces aliasing and
//     the characteristic low-sample-rate crunch.
//
// Per-channel state is kept in \`held[]\` so stereo passes through independently
// while sharing the phase accumulator — that way channel crunch stays aligned.

class BitcrusherProcessor extends AudioWorkletProcessor {
  static get parameterDescriptors() {
    return [
      {
        name: 'bits',
        defaultValue: 16,
        minValue: 1,
        maxValue: 16,
        automationRate: 'k-rate',
      },
      {
        name: 'freq',
        defaultValue: 44100,
        minValue: 200,
        maxValue: 48000,
        automationRate: 'k-rate',
      },
    ];
  }

  constructor() {
    super();
    this.phase = 0;
    this.held = [];
  }

  process(inputs, outputs, parameters) {
    const input = inputs[0];
    const output = outputs[0];
    if (!input || input.length === 0 || !output || output.length === 0) {
      return true;
    }

    const bits = parameters.bits[0] ?? 16;
    const freq = parameters.freq[0] ?? sampleRate;
    // step = 1 / (2^(bits-1)) — full-range quantization step for signed samples
    const step = Math.pow(2, 1 - bits);
    const phaseInc = Math.min(1, freq / sampleRate);

    const firstInput = input[0];
    const nFrames = firstInput ? firstInput.length : 0;

    for (let i = 0; i < nFrames; i++) {
      this.phase += phaseInc;
      if (this.phase >= 1) {
        this.phase -= 1;
        for (let ch = 0; ch < input.length; ch++) {
          const inChan = input[ch];
          const sample = inChan ? inChan[i] : 0;
          this.held[ch] = Math.round(sample / step) * step;
        }
      }
      for (let ch = 0; ch < output.length; ch++) {
        const outChan = output[ch];
        if (outChan) outChan[i] = this.held[ch] ?? 0;
      }
    }
    return true;
  }
}

registerProcessor('bitcrusher-processor', BitcrusherProcessor);
`;
